module.exports = __webpack_public_path__ + "static/media/rating.a0b08b9c.png";